import { useEffect, useState } from "react";
import { useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";
import { ENVIRONMENT_CONFIG } from "shared/globals";

const iboLookupApiBase = (
  ENVIRONMENT_CONFIG.permissionsApiBase || ENVIRONMENT_CONFIG.apiBase
).replace(/\/$/, "");

export function useIBOSearch(term = "", limit = 50) {
  const { logError } = useLogger({ prefix: "useIBOSearch" });
  const [searchResults, setSearchResults] = useState([]);

  const { data, loading, error } = useAuthedRequest(
    term.trim().length < 3
      ? null
      : `${iboLookupApiBase}/membership/lookup/ibo?term=${encodeURIComponent(
          term
        )}&limit=${limit}`
  );

  useEffect(() => {
    if (error) {
      logError(error);
    }
  }, [error]);

  useEffect(() => {
    if (data != null) {
      setSearchResults(data);
    }
  }, [data]);

  return {
    searchResults,
    isLoading: loading,
  };
}
